module.exports = __webpack_public_path__ + "static/media/MIAB9989-180731-145_Small.b18d570e.jpg";